module.exports = __webpack_public_path__ + "static/media/scrap-car-removal.39d14483.png";